import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    Menu,
    MenuItem,
    TextField,
    Theme,
    Typography,
    useTheme
} from "@mui/material";
import { useEffect, useState } from "react";
import {
    CheckIcon,
    CrossIcon,
    DialogCloseIcon,
    DropDownIcons,
    SearchIcon,
    UnCheckIcon
} from "../../../../assets/SvgIcons";
import {
    ColorMap,
    FilterCheckboxProps,
    navigationData
} from "../../types";
import OrderInfo from "./OrderInfo";
import TablePaginationComponent from "../../common/customTable/TablePaginationComponent";
import { useHistory } from "react-router";
import { getOrderDetails, getOrderStatus, getOrderType } from "../../../../redux-store/actions/funds";
import { useDispatch, useSelector } from "react-redux";
import load from 'lodash';
import { useDebounce } from "../../../../utils/useDebounce";
import { RootStateType } from "../../../../redux-store/reducers";
import { USER_ROLES } from "../../../../utils/constant";
import { isFamilyView, isRMLikeRole } from "../../../../utils/utilityFunctions";

const orderCategories = ["Recommended", "DIY"]

export const colorMap: ColorMap = {
    Successful: 'success.500',
    "In Progress": 'warning.500',
    Failed: 'error.500'
}

interface Payload {
    clientCode?: string,
    currentPage?: number,
    searchInput?: string,
    trType?: Array<string | number>,
    status?: Array<string | number>
    portfolioId?: string,
    isRecommended: boolean,
    isDiy: boolean
}

function ColorCircle(
    { backgroundColor }: { backgroundColor: string }
): JSX.Element {
    return (
        <Box
            sx={{
                width: "11px",
                height: "11px",
                borderRadius: "50%",
                backgroundColor
            }}
        />
    )
}

function FilterCheckbox({
    value,
    label,
    checked,
    handleChange,
    circleBackgroundColor
}: FilterCheckboxProps): JSX.Element {
    return (
        <FormControlLabel
            value={value}
            // Stop clicks on the checkbox/label from bubbling up to the parent
            // MenuItem's onClick, which would cause a double-toggle.
            // MenuItem.onClick still fires for keyboard activation (Space/Enter).
            onClick={(e) => e.stopPropagation()}
            control={
                <Checkbox
                    size="small"
                    checkedIcon={<CheckIcon />}
                    icon={<UnCheckIcon />}
                    sx={{
                        "&.MuiCheckbox-root": {
                            padding: "4px 9px"
                        },
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    }}
                    checked={checked}
                    onChange={handleChange}
                />
            }
            label={
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "10px",
                    }}
                >
                    {circleBackgroundColor &&
                        <ColorCircle
                            backgroundColor={circleBackgroundColor} />
                    }
                    <Typography
                        variant="body_500"
                        sx={(theme: Theme) => ({
                            color: theme.palette.text.secondary,
                            wordBreak: "break-all"
                        })}>
                        {label}
                    </Typography>
                </Box>
            }
            sx={{
                display: 'flex',
                columnGap: "10px",
                width: "100%",
                margin: "0px"
            }}
        />
    );
}


export default function Orders(props: navigationData): JSX.Element {
    const history = useHistory()
    const { pathname: pathName, state } = history.location
    const theme = useTheme()
    const dispatch = useDispatch()
    const statemanage = (state as { clientCode?: string, tab?: string }) ?? ''
    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);
    // console.log('clientCode', clientCode)

    const [currentOrderCategory, setCurrentOrderCategory] = useState<string>(statemanage?.tab || "Recommended")
    const [orderTypeDropdownEl, setOrderTypeDropdownEl] = useState<null | HTMLElement>(null);
    const [orderStatusDropdownEl, setOrderStatusDropdownEl] = useState<null | HTMLElement>(null);
    const [orderTypes, setOrderTypes] = useState<Array<{ typeId: number | string, typeName: string, checked: boolean }>>([])
    const [orderTypeArray, setOrderTypeArray] = useState<Array<number | string>>([])

    const [orderStatus, setOrderStatuse] = useState<Array<{ statusId: number | string, statusName: string, checked: boolean }>>([
    ])
    const [orderStatusArray, setOrderStatusArray] = useState<Array<number | string>>([])

    const [orderList, setOrderList] = useState<Array<any>>([])

    const [search, setSearch] = useState<string>("")

    const [detail, setDetail] = useState<Array<any>>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [totalPage, setTotalPage] = useState<number>(0)
    const [currentPage, setCurrentPage] = useState<number>(0)

    const [orderCategories, setOrderCategories] = useState([{
        name: "Recommended",
        count: 0
    }, {
        name: "DIY",
        count: 0
    }])
    const isOrderTypeDropdownOpen = Boolean(orderTypeDropdownEl);
    const isOrderStatusDropdownOpen = Boolean(orderStatusDropdownEl);


    const debounce = useDebounce(search, 500)
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { investorClientId  , viewAsFamilyId=""} = useSelector((state: RootStateType) => state.id)
    
     const clientCode = isRMLikeRole(role) ? props?.clientCode : isFamilyView(pathName) ? viewAsFamilyId : investorClientId;

    useEffect(() => {
        setIsLoading(true)
        const fetchApi = async () => {

            const payload: Payload = {
                "clientCode": clientCode,
                "currentPage": currentPage + 1,
                // "searchInput": debounce,
                portfolioId: selectedPortfolio?.value,
                isRecommended: currentOrderCategory === 'Recommended',
                isDiy: currentOrderCategory === "DIY",
                searchInput: debounce || '',
                trType: orderTypeArray,
                status: orderStatusArray,
            }


            const res = (await dispatch(getOrderDetails(payload))) as { orders?: Array<any>, totalCount?: number, diyCount?: number, recommendedCount?: number };
            // const group = Object.groupBy(res, (item: any) => item.orderDate )

            setTotalPage(res?.totalCount as number)
            setOrderCategories([
                {
                    name: "Recommended",
                    count: res?.recommendedCount ?? 0
                },
                {
                    name: "DIY",
                    count: res?.diyCount ?? 0
                }
            ])
            const groupBy = load.groupBy(res?.orders, 'orderDate')
            // console.log('groupBy', groupBy)
            const group = Object.entries(groupBy).map(([key, value]) => {
                return {
                    value
                }
            })

            // console.log(group)
            const dummy = group.map((item: any) => {
                // console.log('value', item.value)
                return {
                    orderDate: item?.value[0]?.orderDate,
                    schemes: item.value.map((item: any) => {
                        return {
                            amcId: item?.schemes?.[0]?.amcId ?? '',
                            bseId: item?.schemes?.[0]?.bseOrderId || "",
                            status: item.schemes[0].status,
                            fromSchemeName: item.schemes[0].schemeName,
                            fromSchemeImage: null,
                            toSchemeName: item.schemes?.[0].toSchemeName ?? '',
                            toSchemeImage: null,
                            purchaseType: item.schemes[0].trType,
                            amount: item.schemes[0].orderVal,
                            units: item.schemes[0].units,
                            id: item?.schemes[0]?.id,
                            transNo: item?.schemes[0]?.TransNo,
                            isOTPVerified: item?.schemes?.[0]?.isOTPVerified
                        }
                    })

                    //differect based on date

                }
            })



            const dummy2 = [...dummy].map((item: any) => {
                // console.log(item?.orderDate)
                const formattedData = item.schemes.reduce((acc: any, scheme: any) => {
                    const { id } = scheme;
                    if (!acc[id]) {
                        acc[id] = [];
                    }
                    acc[id].push(scheme);
                    return acc;
                }, {});

                const result = {
                    orderDate: item.orderDate,
                    schemes: Object.values(formattedData).sort((a: any, b: any) => Number(b[0].id) - Number(a[0].id)),
                };

                return result
            })


            setOrderList(dummy2 as any)
            setIsLoading(false)
            // console.log('dummy2', dummy2)
        }
        fetchApi()
    }, [debounce, orderStatusArray, orderTypeArray, currentPage, currentOrderCategory])

    useEffect(() => {
        const fetch = async () => {
            const orederType = (await dispatch(getOrderType())) as unknown || Array<any>;
            const orederStatus = (await dispatch(getOrderStatus())) as unknown || Array<any>;

            setOrderTypes((orederType as Array<any> || [])?.map((item: any) => {
                return {
                    typeId: item?.orderTypeId,
                    typeName: item?.orderTypeValue,
                    checked: false
                }
            }))

            setOrderStatuse((orederStatus as Array<any> || [])?.map((item: any) => {
                return {
                    statusId: item?.orderStatusId,
                    statusName: item?.orderStatusValue,
                    checked: false
                }
            }))
        }

        fetch()
    }, [])

    // console.log('orderList', orderList)

    const handleOrderTypeDropdownOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setOrderTypeDropdownEl(event.currentTarget);
    };

    const handleOrderTypeDropdownClose = () => {
        setOrderTypeDropdownEl(null);
    };


    // console.log('orderTypeArray', orderTypeArray)
    const handleOrderTypeDropdownItemsClick = async (id: number | string) => {
        // console.log("order Type id", id)
        let orderType: string[] = []
        setOrderTypes((pre: Array<{ typeId: number | string, typeName: string, checked: boolean }>) => {

            const final = pre.map((item: { typeId: number | string, typeName: string, checked: boolean }) => {
                if (item.typeId === id) {
                    setOrderTypeArray((preNum: Array<number | string>) => {
                        if (preNum.includes(id)) {
                            return preNum.filter((item: number | string) => item !== id)
                        }
                        return [...preNum, id]
                    })
                    return {
                        ...item,
                        checked: !item.checked
                    }
                }
                return item
            })

            orderType = final.filter((item: { checked: boolean }) => item.checked === true).map((item: { typeId: number | string, typeName: string, checked: boolean }) => item.typeName === "Invest" ? "FRESH" : item.typeName)

            return final
        })

    }

    const handleOrderStatusDropdownOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setOrderStatusDropdownEl(event.currentTarget);
    };

    const handleOrderStatusDropdownClose = () => {
        setOrderStatusDropdownEl(null);
    };

    // console.log('orderStatusArray', orderStatusArray)
    const handleOrderStatusDropdownItemsClick = async (id: number | string) => {

        let status: string[] = []
        // console.log("order Status id", id)
        setOrderStatuse((pre: Array<{ statusId: number | string, statusName: string, checked: boolean }>) => {


            const final = pre.map((item: { statusId: number | string, statusName: string, checked: boolean }) => {
                if (item.statusId === id) {
                    setOrderStatusArray((preNum: Array<number | string>) => {
                        if (preNum.includes(id)) {
                            return preNum.filter((item: number | string) => item !== id)
                        }
                        return [...preNum, id]
                    })
                    return {
                        ...item,
                        checked: !item.checked
                    }
                }
                return item
            })

            status = final.filter((item: { checked: boolean }) => item.checked === true).map((item: { statusId: number | string, statusName: string }) => item.statusName)

            return final
        })

        // console.log("status", status)

    }

    const handleViewDetailsClick = (orderId: number, schemeId: number, id: number | string, indSchemeId: number | string) => {
        console.log("Scheme clicked", "orderId", orderId, "schemeId", schemeId)
        history.push(`${pathName}/${indSchemeId}/order-details`, {
            id: id,
            clientCode: clientCode,
            tab: currentOrderCategory,
            indSchemeId: indSchemeId
        })
    }

    const handleRemoveLeavesFilter = async (type: string, id: number | string) => {
        // console.log("remove leaves filter", type, id)
        let orderType
        let orderStatus
        if (type === 'orderType') setOrderTypes((pre: Array<{ typeId: number | string, typeName: string, checked: boolean }>) => {

            const final = pre.map((item: { typeId: number | string, typeName: string, checked: boolean }) => {
                if (item.typeId === id) {
                    setOrderTypeArray((preNum: Array<number | string>) => {
                        if (preNum.includes(id)) {
                            return preNum.filter((item: number | string) => item !== id)
                        }
                        return [...preNum, id]
                    })
                    return {
                        ...item,
                        checked: !item.checked
                    }
                }
                return item
            })

            orderType = final.filter((item: { checked: boolean }) => item.checked === true).map((item: { typeId: number | string, typeName: string, checked: boolean }) => item.typeName === "Invest" ? "FRESH" : item.typeName)

            return final
        })
        if (type === 'orderStatus') setOrderStatuse((pre: Array<{ statusId: number | string, statusName: string, checked: boolean }>) => {
            const final = pre.map((item: { statusId: number | string, statusName: string, checked: boolean }) => {
                if (item.statusId === id) {
                    setOrderStatusArray((preNum: Array<number | string>) => {
                        if (preNum.includes(id)) {
                            return preNum.filter((item: number | string) => item !== id)
                        }
                        return [...preNum, id]
                    })
                    return {
                        ...item,
                        checked: !item.checked
                    }
                }
                return item
            })

            orderStatus = final.filter((item: { checked: boolean }) => item.checked === true).map((item: { statusId: number | string, statusName: string }) => item.statusId)

            return final
        })

    }

    const handlePage = async (page: number) => {
        // console.log("page", page)
        setCurrentPage(page)


    }

    const handleSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value)
    }

    const handleCategoryTab = async (category: string) => {
        setCurrentOrderCategory(category)
        setCurrentPage(0)
    }

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    borderRadius: "25px",
                    padding: "35px",
                    backgroundColor: theme.palette.common.white,
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
                })}
            >
                {/* Heading start */}
                <Typography
                    variant="h2"
                    sx={(theme: Theme) => ({
                        color: theme.palette.text.primary
                    })}
                >
                    Orders
                </Typography>
                {/* Heading end */}

                {/* Tabs start */}
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        display: "flex",
                        columnGap: "20px",
                        paddingBottom: "15px",
                        borderBottom: `0.5px solid ${theme.palette.customColors.pastelGrey}`
                    })}
                    role="tablist"
                    onKeyDown={(e: React.KeyboardEvent) => {
                        const tabs = orderCategories.map(({ name = '' }) => name);
                        const currentIndex = tabs.indexOf(currentOrderCategory);
                        if (e.key === 'ArrowRight') {
                            e.preventDefault();
                            const next = tabs[(currentIndex + 1) % tabs.length];
                            handleCategoryTab(next);
                            document.getElementById(`orders-tab-${next.toLowerCase()}`)?.focus();
                        } else if (e.key === 'ArrowLeft') {
                            e.preventDefault();
                            const prev = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
                            handleCategoryTab(prev);
                            document.getElementById(`orders-tab-${prev.toLowerCase()}`)?.focus();
                        }
                    }}
                >
                    {orderCategories.map(({ name = '', count = 0 }) => (
                        <Button
                            key={name}
                            onClick={() => handleCategoryTab(name)}
                            id={`orders-tab-${name.toLowerCase()}`}
                            aria-controls="orders-tabpanel"
                            aria-selected={currentOrderCategory === name}
                            tabIndex={currentOrderCategory === name ? 0 : -1}
                            role="tab"
                            sx={(theme: Theme) => ({
                                borderRadius: "7px",
                                backgroundColor: currentOrderCategory === name ?
                                    theme.palette.primary[500] : theme.palette.common.white,
                                padding: "5px 15px",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "row",
                                gap: "10px"
                            })}
                        >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: currentOrderCategory === name ?
                                        theme.palette.textDark.primary : theme.palette.text.secondary
                                })}
                            >
                                {name}
                            </Typography>
                            <Typography
                                component={'span'}
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    padding: '0px 10px',
                                    backgroundColor: currentOrderCategory === name ?
                                        theme.palette.common.white :
                                        theme.palette.primary[100],
                                    color: theme.palette.primary[500],
                                    borderRadius: '7px',
                                    letterSpacing: '0.02px',
                                    // mt: '3px',
                                    // mb: '3px',
                                    // lineHeight: '20px'
                                })}
                            >
                                {count}
                            </Typography>
                        </Button>
                    ))}

                </Box>
                {/* Tabs end */}

                {/* Search and filter container Start */}
                <Grid
                    container
                    sx={{
                        display: "flex",
                        marginTop: "25px",
                    }}
                    columnSpacing={2}
                    rowSpacing={2}
                >
                    {/* Search Start */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        lg={8}
                    >
                        <TextField
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            sx={{
                                                display: search.length > 0 ? 'inline-flex' : 'none',
                                            }}
                                            onClick={() => setSearch('')}
                                            aria-label="Clear Search"
                                        >
                                            <DialogCloseIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                sx: (theme: Theme) => ({
                                    borderRadius: '5px',
                                    height: '47.17px',
                                    border: `1px solid ${theme.palette.text.secondary}B2`,
                                    '& fieldset': {
                                        border: 'none',
                                    },
                                    '& input': {
                                        paddingLeft: '10px',
                                        ...theme.typography.body_500,
                                        color: theme.palette.text.primary,
                                        '::placeholder': {
                                            ...theme.typography.subtitle_400,
                                            color: theme.palette.text.secondary,
                                            opacity: 1,
                                        },
                                    },
                                }),
                            }}

                            value={search}
                            placeholder="Search by AMC"
                            onChange={handleSearch}
                        />
                    </Grid>
                    {/* Search End */}

                    {/* Order Type Filter Button Start */}
                    <Grid
                        item
                        xs={6}
                        md={3}
                        lg={2}
                    >
                        <Button
                            id="order-type-button"
                            aria-controls={isOrderTypeDropdownOpen ? 'order-type-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={isOrderTypeDropdownOpen ? 'true' : undefined}
                            onClick={handleOrderTypeDropdownOpen}
                            endIcon={<DropDownIcons />}
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "5px",
                                border: `1px solid ${theme.palette.text.secondary}B2`,
                                backgroundColor: theme.palette.common.white,
                                color: theme.palette.text.primary,
                                height: "47.17px",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "12px 20px",
                                ...theme.typography.body_500,
                                '&:hover': {
                                    backgroundColor: theme.palette.common.white,
                                },
                            })}
                            TouchRippleProps={{
                                style: {
                                    color: theme.palette.grey[300]
                                }
                            }}
                        >
                            Order Type
                        </Button>
                    </Grid>
                    {/* Order Type Filter Button End */}

                    {/* Order Status Filter Button Start */}
                    <Grid
                        item
                        xs={6}
                        md={3}
                        lg={2}
                    >
                        <Button
                            id="order-status-button"
                            aria-controls={isOrderStatusDropdownOpen ? 'order-status-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={isOrderStatusDropdownOpen ? 'true' : undefined}
                            onClick={handleOrderStatusDropdownOpen}
                            endIcon={<DropDownIcons />}
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "5px",
                                border: `1px solid ${theme.palette.text.secondary}B2`,
                                backgroundColor: theme.palette.common.white,
                                color: theme.palette.text.primary,
                                height: "47.17px",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "12px 20px",
                                ...theme.typography.body_500,
                                '&:hover': {
                                    backgroundColor: theme.palette.common.white,
                                },
                            })}
                            TouchRippleProps={{
                                style: {
                                    color: theme.palette.grey[300]
                                }
                            }}
                        >
                            Order Status
                        </Button>
                    </Grid>
                    {/* Order Status Filter Button End */}

                </Grid>
                {/* Search and filter container End */}

                {/* Filter Leaves Container Start */}
                <Box
                    sx={{
                        marginTop: "25px",
                        display: "flex",
                        gap: "15px",
                        flexWrap: "wrap",
                    }}
                >
                    {[...orderStatus].filter((item) => item.checked)?.map((status, i) => (
                        <Button
                            key={i}
                            variant="contained"
                            startIcon={<CrossIcon />}
                            onClick={() => handleRemoveLeavesFilter('orderStatus', status?.statusId)}
                            sx={(theme: Theme) => ({
                                borderRadius: "61px",
                                backgroundColor: theme.palette.primary[100],
                                padding: "5px 16px",
                                color: theme.palette.text.primary,
                                whiteSpace: "nowrap",
                                boxShadow: "none",
                                ...theme.typography.subtitle_400,
                                "& .MuiButton-startIcon": {
                                    paddingTop: "2px"
                                },
                                "&:hover": {
                                    backgroundColor: theme.palette.primary[100],
                                    boxShadow: "none"
                                }
                            })}
                        >
                            {status?.statusName}
                        </Button>
                    ))}
                    {[...orderTypes].filter((item) => item.checked)?.map((type, i) => (
                        <Button
                            key={i}
                            variant="contained"
                            startIcon={<CrossIcon />}
                            onClick={() => handleRemoveLeavesFilter('orderType', type?.typeId)}
                            sx={(theme: Theme) => ({
                                borderRadius: "61px",
                                backgroundColor: theme.palette.primary[100],
                                padding: "5px 16px",
                                color: theme.palette.text.primary,
                                whiteSpace: "nowrap",
                                boxShadow: "none",
                                ...theme.typography.subtitle_400,
                                "& .MuiButton-startIcon": {
                                    paddingTop: "2px"
                                },
                                "&:hover": {
                                    backgroundColor: theme.palette.primary[100],
                                    boxShadow: "none"
                                }
                            })}
                        >
                            {type?.typeName}
                        </Button>

                    ))}
                </Box>
                {/* Filter Leaves Container End */}

                {/* Order Info Container Start */}
                <Box
                    id="orders-tabpanel"
                    role="tabpanel"
                    aria-labelledby={`orders-tab-${currentOrderCategory.toLowerCase()}`}
                    sx={{
                        marginTop: "25px",
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "30px"
                    }}
                >
                    {/* {ordersInfoData?.map(order => ( */}
                    {orderList?.map((order, i) => (
                        <OrderInfo
                            key={i}
                            data={order}
                            // data={[1, 2]}
                            isLoading={isLoading}
                            handleViewDetailsClick={handleViewDetailsClick}
                        />
                    ))}

                    {isLoading &&
                        <OrderInfo
                            // key={order?.orderId}
                            // data={order}
                            data={[1, 2]}
                            isLoading={isLoading}
                            handleViewDetailsClick={handleViewDetailsClick}
                        />
                    }

                    {!isLoading && orderList.length === 0 && (
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                            <Typography
                                variant="body_600"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                No Result Found
                            </Typography>
                        </Box>
                    )}
                </Box>
                {/* Order Info Container End */}

                {/* Pagination Start */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        marginTop: "10px"
                    }}
                >
                    <TablePaginationComponent
                        rowsPerPageOptions={[]}
                        tableDataCount={totalPage as number}
                        currentPage={currentPage as number}
                        handlePageChange={(e, newPage) => handlePage(newPage)}
                        handleRowsPerPageChange={() => console.log("Pagination Row Per Page Change")}
                    />
                </Box>
                {/* Pagination End */}


            </Box >

            {/* Order Type Filter Dropdown Menu Start */}
            < Menu
                id="order-type-menu"
                anchorEl={orderTypeDropdownEl}
                open={isOrderTypeDropdownOpen}
                onClose={handleOrderTypeDropdownClose}
                MenuListProps={{
                    'aria-labelledby': 'order-type-button',
                    onKeyDown: (e: React.KeyboardEvent<HTMLUListElement>) => {
                        if (e.key === 'Tab') {
                            // Intercept Tab so it cycles through items instead of closing the menu.
                            e.preventDefault();
                            e.stopPropagation();
                            const items = Array.from(
                                (e.currentTarget as HTMLElement).querySelectorAll<HTMLElement>('[role="menuitem"]')
                            );
                            const currentIdx = items.findIndex(item => item === document.activeElement);
                            const nextIdx = e.shiftKey
                                ? (currentIdx - 1 + items.length) % items.length
                                : (currentIdx + 1) % items.length;
                            items[nextIdx]?.focus();
                        }
                    },
                    sx: {
                        padding: "8px 0px",
                        '& > :not(:last-child)': {
                            marginBottom: '5px',
                        },
                    }
                }}
                slotProps={{
                    paper: {
                        style: {
                            width: '275px',
                            borderRadius: "12px",
                            backgroundColor: theme.palette.common.white,
                        }
                    }
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                {orderTypes.map((obj) =>
                    <MenuItem
                        key={obj.typeId}
                        onClick={() => handleOrderTypeDropdownItemsClick(obj.typeId)}
                        sx={{
                            padding: "5px",
                            '&:hover': {
                                backgroundColor: theme.palette.primary[100],
                                borderRadius: "8px",
                                color: theme.palette.primary[500]
                            },
                        }}
                    >
                        <FilterCheckbox
                            key={obj.typeId}
                            value={obj.typeId}
                            label={obj.typeName}
                            checked={obj.checked}
                            handleChange={() => handleOrderTypeDropdownItemsClick(obj.typeId)}
                        />
                    </MenuItem>
                )}
            </Menu >
            {/* Order Type Filter Dropdown Menu End */}

            {/* Order Status Filter Dropdown Menu Start */}
            < Menu
                id="order-status-menu"
                anchorEl={orderStatusDropdownEl}
                open={isOrderStatusDropdownOpen}
                onClose={handleOrderStatusDropdownClose}
                MenuListProps={{
                    'aria-labelledby': 'transact-button',
                    onKeyDown: (e: React.KeyboardEvent<HTMLUListElement>) => {
                        if (e.key === 'Tab') {
                            e.preventDefault();
                            e.stopPropagation();
                            const items = Array.from(
                                (e.currentTarget as HTMLElement).querySelectorAll<HTMLElement>('[role="menuitem"]')
                            );
                            const currentIdx = items.findIndex(item => item === document.activeElement);
                            const nextIdx = e.shiftKey
                                ? (currentIdx - 1 + items.length) % items.length
                                : (currentIdx + 1) % items.length;
                            items[nextIdx]?.focus();
                        }
                    },
                    sx: {
                        padding: "8px 0px",
                        '& > :not(:last-child)': {
                            marginBottom: '5px',
                        },
                    }
                }}
                slotProps={{
                    paper: {
                        style: {
                            width: '275px',
                            borderRadius: "12px",
                            backgroundColor: theme.palette.common.white,
                        }
                    }
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                {orderStatus.map((obj) =>
                    <MenuItem
                        key={obj.statusId}
                        onClick={() => handleOrderStatusDropdownItemsClick(obj.statusId)}
                        sx={{
                            padding: "5px",
                            '&:hover': {
                                backgroundColor: theme.palette.primary[100],
                                borderRadius: "8px",
                                color: theme.palette.primary[500]
                            },
                        }}
                    >
                        <FilterCheckbox
                            value={obj.statusId}
                            label={obj.statusName}
                            checked={obj.checked}
                            circleBackgroundColor={colorMap[obj.statusName]}
                            handleChange={() => handleOrderStatusDropdownItemsClick(obj.statusId)}
                        />
                    </MenuItem>
                )}
            </Menu>
            {/* Order Status Filter Dropdown Menu End */}
        </>
    )
}